function getFittingRoom() {
  return JSON.parse(localStorage.getItem('fittingRoom') || '[]');
}

function saveFittingRoom(items) {
  localStorage.setItem('fittingRoom', JSON.stringify(items));
  updateFittingRoomCount();
}

function addToFittingRoom(event, product) {
  event.preventDefault();
  let items = getFittingRoom();

  const exists = items.some(i => i.id === product.id);
  if (exists) {
    showFittingRoomToast('Already in your fitting room');
    return;
  }

  items.push(product);
  saveFittingRoom(items);
  showFittingRoomToast('Added to fitting room');
}

function removeFromFittingRoom(id) {
  let items = getFittingRoom().filter(i => i.id !== id);
  saveFittingRoom(items);
  renderFittingRoomPanel();
}

function updateFittingRoomCount() {
  const count = getFittingRoom().length;
  const badge = document.getElementById('fitting-room-count');
  if (badge) {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'inline-block' : 'none';
  }
  document.body.classList.toggle('fitting-room-has-items', count > 0);
}

function showFittingRoomToast(message) {
  const toast = document.createElement('div');
  toast.className = 'fitting-room-toast';
  toast.textContent = message;
  document.body.appendChild(toast);
  setTimeout(() => toast.classList.add('active'), 10);
  setTimeout(() => {
    toast.classList.remove('active');
    setTimeout(() => toast.remove(), 300);
  }, 2000);
}

function renderFittingRoomPanel() {
  const items = getFittingRoom();
  const list = document.getElementById('fitting-room-items');
  const emptyState = document.getElementById('fitting-room-empty');
  const formFields = document.getElementById('fitting-room-hidden-fields');

  if (!list) return;

  list.innerHTML = '';
  formFields.innerHTML = '';

  if (items.length === 0) {
    emptyState.style.display = 'block';
  } else {
    emptyState.style.display = 'none';
    items.forEach((item, index) => {
      list.innerHTML += `
        <div class="fitting-room-item">
          <img src="${item.image}" alt="${item.title}">
          <div class="fitting-room-item__details">
            <p>${item.title}</p>
            <p class="fitting-room-item__variant">${item.variant}</p>
          </div>
          <button type="button" onclick="removeFromFittingRoom('${item.id}')">×</button>
        </div>
      `;
      formFields.innerHTML += `
        <input type="hidden" name="contact[Item ${index + 1}]" value="${item.title} — ${item.variant} (${window.location.origin}${item.url})">
      `;
    });
  }
}

function toggleFittingRoomPanel() {
  const panel = document.getElementById('fitting-room-panel');
  panel.classList.toggle('active');
  if (panel.classList.contains('active')) renderFittingRoomPanel();
}

document.addEventListener('DOMContentLoaded', updateFittingRoomCount);